// there are the same breakpoints as primer uses
// defined here as javascript variables as media queries do not
// accept native css variables
export const breakpoints = {
  0: '544px',
  1: '768px',
  2: '1012px',
  3: '1280px',
};
